import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/core-js/modules/es6.array.iterator.js";
import "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/core-js/modules/es6.promise.js";
import "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/core-js/modules/es6.object.assign.js";
import "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import lodash from 'lodash';
import VueClipboard from 'vue-clipboard2';
Vue.prototype.lodash = lodash;
import '@/styles/index.scss'; // global css
import App from "./App";
import store from "./store";
import router from "./router";
import remindPerson from '@/components/person-select/index.vue';
Vue.component('remind-person', remindPerson);
import YLImage from '@/components/YLImage/main.vue';
Vue.component('yl-image', YLImage);
import '@/icons'; // icon
import "./utils/rem";
import '@/permission'; // permission control
import "./utils/tools";
import "@/assets/iconfont/iconfont.css";
import { Watermark } from '@/utils/watermark';
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
Vue.prototype.$watermark = new Watermark({
  content: '',
  width: '180',
  height: '120'
});

// 引入阿里图标库 示例 <span class="iconfont icon-xuzhi"></span>
var iconfontUrl = '//at.alicdn.com/t/c/font_1085057_wuhdrsn8rp.css';
var link = document.createElement('link');
link.type = 'text/css';
link.rel = 'stylesheet';
link.href = iconfontUrl;
document.head.appendChild(link);

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.VUE_APP_NAME === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })

Vue.prototype.$url = 'https://res.youlianfuwu.com/saas';
Vue.prototype.$ossurl = process.env.VUE_APP_NAME === 'production' ? 'https://ossres.youlianfuwu.com/' : 'https://ossrestest.youlianfuwu.com/';
// 自定义按钮权限指令
Vue.directive('has', {
  inserted: function inserted(el, binding) {
    var roles = store.state.user.roles;
    if (roles.length > 0) {
      var rolesFlag = roles.includes(binding.value);
      if (!rolesFlag) {
        el.parentNode.removeChild(el);
      }
    }
  }
});
// 单选匡报警告处理 chrome浏览器会出现这个问题。（在Edge浏览器和360浏览器上均无报错现象
Vue.directive('removeAriaHidden', {
  bind: function bind(el, binding) {
    var ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach(function (item) {
      item.removeAttribute('aria-hidden');
    });
  }
});
Vue.use(ElementUI);
Vue.use(VueClipboard);
ElementUI.Table.props.stripe.default = true; // 全局设置表格带斑马线
Vue.config.productionTip = false;
Vue.config.devtools = process.env.VUE_APP_NAME !== 'production';
new Vue({
  el: '#app',
  store: store,
  router: router,
  render: function render(h) {
    return h(App);
  }
});